// extracted by mini-css-extract-plugin
module.exports = {"isRequired":"TradeCreate_isRequired_MAZpi"};